type BrandLogoProps = {
  className?: string;
  variant?: "secondary" | "brandmark";
};

/** CSS selects the correct artwork before hydration, including first visits. */
export function BrandLogo({ className = "", variant = "secondary" }: BrandLogoProps) {
  const secondary = variant === "secondary";
  return (
    <>
      <img
        src={secondary ? "/logo-secondary.svg?v=e00256cfe3" : "/brandmark.svg"}
        alt="Bavimail"
        width={secondary ? 6015 : 1143}
        height={secondary ? 727 : 792}
        className={`theme-when-dark ${className}`}
      />
      <img
        src={secondary ? "/logo-secondary-light.svg?v=3c0c4bfc18" : "/brandmark-light.svg"}
        alt="Bavimail"
        width={secondary ? 6014 : 1143}
        height={secondary ? 727 : 792}
        className={`theme-when-light ${className}`}
      />
    </>
  );
}
